import { translations } from "../../../utils/lang";

export function useBillingAdminText(lang = "en") {
  return translations[lang]?.billing?.admin || translations.en.billing.admin;
}

export function labelFor(map, value) {
  return map?.[value] || map?.unknown || value || "-";
}

export function optionsFromLabels(labels = {}, values = []) {
  return values.map((value) => ({ value, label: labels[value] || labels.unknown || value }));
}
